import { makeRequestCreator } from './common.js'
import store from '@/store'

const SearchAPI = {
   /**
   * 검색어를 이용하여 제품을 검색한다.
   * @param {String} searchText - 검색어
   * @param {Number} page - 페이지 번호
   * @param {Number} pageSize - 페이지 크기
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  searchProduct: (searchText, page, pageSize, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'searchProduct',
      {
        method: 'post',
        url: `/v2/search/product/${store.getters['main/shopSeq']}`,
        data: {
          searchText,
          page,
          pageSize
        }
      },
      successCallback,
      errorCallback
    )
  },
   /**
   * 검색어를 이용하여 태그를 검색한다.
   * @param {String} searchText - 검색어
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  searchTag: (searchText, successCallback = ()=>{}, errorCallback = ()=>{}) => {
    makeRequestCreator(
      'searchTag',
      {
        method: 'post',
        url: `/v2/search/tag/${store.getters['main/shopSeq']}`,
        data: {
          searchText
        }
      },
      successCallback,
      errorCallback
    )
  }
}

export default SearchAPI
